import { PRODUCT_TYPE } from '@cuemath/intel';
import { ACTIONS as logoutActions } from 'actions/logout';
import { ACTIONS } from 'actions/teacher-call';
import { errors } from 'redux-rest-reducer';

const initialState = {
  avFullScreen: false,
  [PRODUCT_TYPE.AV_CALL]: { analyticsMeta: null },
  [PRODUCT_TYPE.BROADCAST]: { isActive: false, callId: null, analyticsMeta: null },
  [PRODUCT_TYPE.SCREEN_GRAB]: { analyticsMeta: null },
  [PRODUCT_TYPE.SCREEN_SHARE]: { analyticsMeta: null },
  [PRODUCT_TYPE.GROUP_CALL]: { analyticsMeta: null },

  teacherClassroomId: null,
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.UPDATE_TEACHER_CALL: {
      return {
        ...state,
        ...payload,
      };
    }
    case ACTIONS.SET_BROADCAST: {
      const { isActive, callId, teacherClassroomId, analyticsMeta } = payload;

      return {
        ...state,
        [PRODUCT_TYPE.BROADCAST]: { isActive, callId, analyticsMeta },
        teacherClassroomId,
      };
    }
    case ACTIONS.SET_RM_CALL: {
      const { callId, userCallId, teacherClassroomId } = payload;

      return {
        ...state,
        [PRODUCT_TYPE.GROUP_CALL]: { callId, userCallId },
        teacherClassroomId,
      };
    }
    case ACTIONS.SET_AV_FULLSCREEN: {
      const { teacherClassroomId, fullScreenOn } = payload;

      return {
        ...state,
        avFullScreen: fullScreenOn,
        teacherClassroomId,
      };
    }
    case ACTIONS.SET_ANALYTICS_META: {
      const { type: productType, analyticsMeta } = payload;
      const prevState = state?.[productType] || {};

      return {
        ...state,
        [productType]: { ...prevState, analyticsMeta },
      };
    }
    case ACTIONS.SET_TEACHER_MEDIA_STATE: {
      return {
        ...state,
        ...payload,
      };
    }
    case ACTIONS.SET_SELECTED_MEDIA_PROVIDER: {
      return {
        ...state,
        ...payload,
      };
    }
    case logoutActions.POST_SUCCESS || errors[401] || ACTIONS.CLEAR_TEACHER_CALL: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}

export const getTeacherCall = (state, teacherClassroomId) => {
  const { teacherClassroomId: stateTeacherClassroomId } = state || {};

  if (stateTeacherClassroomId !== teacherClassroomId) {
    return {};
  }

  return state || {};
};
